export default __webpack_public_path__ + "static/media/programming.9a419b8d.png";